import React, { Component } from 'react'
import SweetAlert from 'react-bootstrap-sweetalert';

class TicketReservated extends Component{
    constructor(){
        super()
        this.state={
            open: false
        }
    }
    hideSweetAlert = () => {
        this.setState({ open: false, selected:''})
        this.props.deleteSeatCart(this.state.selected)
    }
    showSweetAlert = (e) => {
        let selected = e.target.getAttribute('data-index')
        this.setState({ open: true, selected })
    }

    render(){
    return (
        <div className="ticket__container">
            <div className="row">
                <div className="col-md-5 col-sm-12">
                    <span className="float-lg-left">{this.props.ticketName} - <strong>{this.props.seat}</strong></span>
                </div>
                <div className="col-md-4 col-sm-12">
                    <span className="float-lg-left">RD$ {this.props.price}</span>
                </div>
                <div className="col-md-3 col-sm-12">
                    <span className="float-lg-left">{this.props.invited ? "Invitado" : "Socio"}</span>
                </div>
            </div>
            <SweetAlert
                warning
                show={this.state.open}
                showCancel
                confirmBtnText="Confirmar"
                confirmBtnBsStyle="success"
                cancelBtnBsStyle="default"
                cancelBtnText="Cancelar"
                title="¿Desea continuar?"
                onConfirm={this.hideSweetAlert}
                onCancel={this.hideSweetAlert}
            >
                Presione confirmar para eliminar la reserva.
                </SweetAlert>
        </div>
        )
    }
}

export default TicketReservated;


// WEBPACK FOOTER //
// ./src/Components/Ticket/ticketReservated.js